export default "__VITE_ASSET__BL_1SGct__"